import React, {FC, MutableRefObject, useCallback, useMemo} from 'react';
import {FormikHelpers, FormikProps, FormikValues} from 'formik';
import {batch} from 'react-redux';
import {IWithChildren} from 'models/common';
import {Form} from 'forms';
import {FormNameEnum} from 'enums/form';
import {IAddSessionInstrumentsFormValues, addSessionInstrumentsFormValidationSchema} from './config';
import {mapAddInstrumentItemsPayload} from 'admin/resources/learning-paths/views/create';
import {
  useLearningPathBuilderItemsEntities,
  useSessionBuilderStoreActions,
} from 'admin/resources/learning-paths/views/session-builder';

interface IAddSessionInstrumentsFormProps extends IWithChildren {
  id: string;
  formikFormRef: MutableRefObject<FormikProps<FormikValues>>;
  closeDrawerClickHandler?: () => void;
  resetIsDirty: () => void;
}

export const AddSessionInstrumentsForm: FC<IAddSessionInstrumentsFormProps> = ({
  id,
  formikFormRef,
  children,
  closeDrawerClickHandler,
  resetIsDirty,
}) => {
  const {addSessionBuilderInstrumentItems} = useSessionBuilderStoreActions();
  const {instrumentsConcatenatedBaseEntitiesCollection} = useLearningPathBuilderItemsEntities();

  const submitHandler = useCallback(
    ({selectedInstrumentsIds}, {resetForm}: FormikHelpers<any>) => {
      const payload = mapAddInstrumentItemsPayload(
        id,
        selectedInstrumentsIds,
        instrumentsConcatenatedBaseEntitiesCollection
      );

      return batch(() => {
        addSessionBuilderInstrumentItems(payload);
        closeDrawerClickHandler();
        resetForm();
        resetIsDirty();
      });
    },
    [
      id,
      closeDrawerClickHandler,
      addSessionBuilderInstrumentItems,
      instrumentsConcatenatedBaseEntitiesCollection,
      resetIsDirty,
    ]
  );

  const initialValues = useMemo(
    () => ({
      [FormNameEnum.instruments]: [],
      [FormNameEnum.selectedInstrumentsIds]: [],
      [FormNameEnum.selectedInstruments]: [],
    }),
    []
  );

  return (
    <Form.Form<IAddSessionInstrumentsFormValues>
      formikRef={formikFormRef}
      initialValues={initialValues}
      validationSchema={addSessionInstrumentsFormValidationSchema}
      submitHandler={submitHandler}
    >
      {children}
    </Form.Form>
  );
};
